import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';

import CourseSelector from 'modules/courses/components/CourseSelector';

import SubjectItemsSelector from '../../components/SubjectItemsSelector';

const useStyles = makeStyles((theme) => ({
  courseSelector: {
    marginBottom: theme.spacing(2),
  },
}));

const ImportSubjectItemsFromCourse = (props) => {
  const classes = useStyles();
  const { courseSelectorProps, subjectItemsSelectorProps } = props;
  return (
    <Box width="100%" minWidth={600} display="flex" flexDirection="column">
      <CourseSelector {...courseSelectorProps} className={classes.courseSelector} />
      <SubjectItemsSelector {...subjectItemsSelectorProps} />
    </Box>
  );
};

ImportSubjectItemsFromCourse.propTypes = {
  courseSelectorProps: PropTypes.object.isRequired,
  subjectItemsSelectorProps: PropTypes.object.isRequired,
};

export default ImportSubjectItemsFromCourse;
